import React, { Component } from "react";
import { GlobalContext } from "../../../../../../utils/globalprovider";
class SubtitleColorOptions extends Component {



    static contextType = GlobalContext;
    constructor(props) {
        super(props);
        
        this.state = {
            color: this.props.color.toUpperCase(),
            applyColor: this.props.applyColor,
        };
    }

    componentDidUpdate(prevProps)
    {

        if (prevProps.color != this.props.color) 
        {
            this.setState ({color: this.props.color.toUpperCase()})
        }

    }

    notifyChange = () => {
        if (this.props.onChange) {
            this.props.onChange({
                color: this.state.color,
                applyColor: this.state.applyColor,
            });
        }
    };

    getValues ()
    {
            return {
                color: this.state.color,
                applyColor: this.state.applyColor,
                row: this.state.row,
                applyRow: this.state.applyRow
            };

    }
    setValue = (name, value) => {
        this.setState(
            { [name]: value },
            this.notifyChange
        );
    };

    renderRow(children) {
        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "18px",
                    marginBottom: "14px"
                }}
            >
                {children}
            </div>
        );
    }

    render() {

        const tapply = this.context.language == "fr"?"Appliquer":"Apply";

        const tc1 = this.context.language == "fr"?"Bleu":"Blue";
        const tc2 = this.context.language == "fr"?"Vert":"Green";
        const tc3 = this.context.language == "fr"?"Cyan":"Cyan";
        const tc4 = this.context.language == "fr"?"Rouge":"Red";
        const tc5 = this.context.language == "fr"?"Magenta":"Magenta";
        const tc6 = this.context.language == "fr"?"Jaune":"Yellow";
        const tc7 = this.context.language == "fr"?"Blanc":"White";

        const c1 = "#0000FF";
        const c2 = "#00FF00";
        const c3 = "#00FFFF";
        const c4 = "#FF0000";
        const c5 = "#FF00FF";
        const c6 = "#FFFF00";
        const c7 = "#FFFFFF";


        const comboStyle = {
            flex: 1,
            padding: "8px 10px",
            background: "#404040",
            color: this.state.color,
            border: "1px solid #5b5b5b",
            borderRadius: "6px",
            fontSize: "12px",
            outline: "none"
        };

        const checkStyle = {
            display: "flex",
            alignItems: "center",
            color: "#dddddd",
            whiteSpace: "nowrap",
            cursor: "pointer",
            userSelect: "none",
            fontSize: "13px",
        };

        return (

            <div
                style={{
                    width: "98%",
                    background: "black",
                    border: "1px solid #555",
                    borderRadius: "10px",
                    padding: "16px",
                    boxSizing: "border-box",
                    fontFamily: "Segoe UI, sans-serif",
                    marginBottom: "5px",
                    
                }}
            >


                {this.renderRow(
                    <>
                        <select
                            style={comboStyle}
                            value={this.state.color}
                            onChange={(e) => {
                                this.setValue("applyColor", true);
                                this.setValue("color", e.target.value)}}
                        >
                            
                            <option value={c1} style={{color:c1}}>{tc1}</option>
                            <option value={c2} style={{color:c2}}>{tc2}</option>                            
                            <option value={c3} style={{color:c3}}>{tc3}</option>
                            <option value={c4} style={{color:c4}}>{tc4}</option>
                            <option value={c5} style={{color:c5}}>{tc5}</option>
                            <option value={c6} style={{color:c6}}>{tc6}</option>
                            <option value={c7} style={{color:c7}}>{tc7}</option>

                        </select>

                        <label style={checkStyle}>
                            <input
                                type="checkbox"
                                checked={this.state.applyColor}
                                onChange={(e) =>
                                    this.setValue("applyColor", e.target.checked)
                                }
                                style={{
                                    marginRight: 8,
                                    accentColor: "#4ea1ff"
                                }}
                            />
                            {tapply}
                        </label>
                    </>
                )}


            </div>
        );
    }
}

export default SubtitleColorOptions;